import { useMutation, useQueryClient } from '@tanstack/react-query';

import { moveWorkspaceQuizzes } from '../../../api/workspaces/quizzes/moveWorkspaceQuizzes';
import { workspaceKeys } from './workspaceQueryKeyFactory';

export function useMoveWorkspaceQuizzes() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: moveWorkspaceQuizzes,
    onSettled: (data, error, { workspaceId }) => {
      return queryClient.invalidateQueries(
        workspaceKeys.quizzes({ workspaceId })
      );
    },
  });
}
